export default __webpack_public_path__ + "static/media/tel-icon.c616c3d1.svg";